export const periodicityOptions = [
    {
        key: 'MONTHLY',
        value: 'Mensual',
        months: 1
    },
    {
        key: 'QUARTERLY',
        value: 'Trimestral',
        months: 3
    },
    {
        key: 'BIANNUAL',
        value: 'Semestral',
        months: 6
    },
    {
        key: 'ANNUAL',
        value: 'Anual',
        months: 12
    }
];